import React, { useState } from "react";
import axios from "axios";
import { guruUtils } from "../common/Utils";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

export default function AutomationProcessingConfigPage({ automation }) {
  const [partitionDocument, setPartitionDocument] = useState(automation.partitionDocument);

  const partitionDocumentUpdated = async (event) => {
    setPartitionDocument(event.target.checked);

    const response = await axios.put(
      `https://${await guruUtils.apiDomain()}/automations/${automation.id}`,
      {
        partition_document: event.target.checked,
      },
      { headers: await guruUtils.getAuthHeaders() }
    );
    if (response.status !== 200) {
      return `Failed to save partition_document: ${response.status}`;
    }
  };

  return <>
    <Box p={1}>
      <Card className={"detail-card"} variant="outlined">
        <CardContent>
          <Grid container>
            <Grid item xs={12} sx={{ borderBottom: 1, borderColor: "grey.400" }}>
              <Typography variant="h5" component="div" pb={1}>
                Processing
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ pt: 2, borderBottom: 1, borderColor: "grey.400" }}>
              <Typography variant="subtitle1" className={"field-label"}>
                Pre-processing
              </Typography>

            </Grid>
            <Grid item xs={12} pt={1}>
              <FormGroup>
                <FormControlLabel control={<Switch checked={partitionDocument} onChange={partitionDocumentUpdated}/>}
                                  label="Partition Document"/>
              </FormGroup>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  </>;
}
